import './header.css';
import optionsList from './header-options.json'
import { useContext, useState } from 'react';
import { LanguageContext } from '../../contexts/languageContext.tsx';

function Header({onClick} : any) {
    const langContext = useContext(LanguageContext);

    const [lang, setLang] = useState(langContext) 
    const isMobile: boolean = window.screen.width < 768;

    const handleLanguageChange = (l: string) => {
        onClick(l.toLowerCase());
        sessionStorage.setItem("lang", l.toLowerCase());
        setLang(l.toLowerCase())
    }
 
    return (
        <>
            <nav id='header' >
                {optionsList.options.map((opt: HeaderOption) =>
                    <a href={opt.url}>
                        <p key="opt.value" className='header-option'>{opt.value}</p>
                    </a>
                )}
                <div hidden={true} id='language-select'>
                    <select value={lang} onChange={e => handleLanguageChange(e.target.value)}>
                        <option value="en">EN</option>
                        <option value="it">IT</option>
                    </select>
                </div>
            </nav>
        </>
        
    )
}

export { Header };

interface HeaderOption {
    value: string;
    url: string
}